import { render, staticRenderFns } from "./ActivateUser.vue?vue&type=template&id=27fa558e&scoped=true&"
import script from "./ActivateUser.vue?vue&type=script&lang=js&"
export * from "./ActivateUser.vue?vue&type=script&lang=js&"
import style0 from "./ActivateUser.vue?vue&type=style&index=0&id=27fa558e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa558e",
  null
  
)

export default component.exports